import React from 'react';
import { Link } from 'react-router-dom';
import { LeafIcon, PhoneIcon, MessageSquareIcon } from 'lucide-react';
import { christmasContacts, christmasQuoteHref } from '../../../data/christmasContacts';
const pageLinks = [{
  label: 'Free Estimate',
  href: '#christmas-estimate'
}, {
  label: 'About Us',
  href: '#christmas-about'
}, {
  label: 'Our Process',
  href: '#christmas-process'
}, {
  label: 'Services',
  href: '#lighting-options'
}, {
  label: 'Gallery',
  href: '#christmas-gallery'
}, {
  label: 'FAQ',
  href: '#christmas-faq'
}];
export function ChristmasFooter() {
  return <footer id="christmas-contact" className="scroll-mt-32 bg-forest-900 text-white" data-id="element-177" data-mp="164smiy4cojiz">
      <div aria-hidden="true" className="flex h-1.5 w-full" data-id="element-178" data-mp="1a64a6y3nyuoj">
        <span className="flex-1 bg-olive" data-id="element-179" data-mp="1a5kw5sh4wqfs" />
        <span className="flex-1 bg-[#C62828]" data-id="element-180" data-mp="37w5obeb0ubat" />
        <span className="flex-1 bg-[#E3C77F]" data-id="element-181" data-mp="37xgpr7gzv6yr" />
      </div>
      <div className="mx-auto max-w-7xl px-5 pb-10 pt-16 sm:px-8" data-id="element-182" data-mp="3bwxvm20c264g">
        <div className="grid gap-12 lg:grid-cols-12" data-id="element-183" data-mp="3bzanp7zt1wv8">
          <div className="lg:col-span-4" data-id="element-184" data-mp="28vufxbgsnyet">
            <Link to="/" className="inline-flex items-center gap-3" data-id="element-185" data-mp="28wm44182atv2">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-olive" data-id="element-186" data-mp="242hwdfqz2hsx">
                <LeafIcon className="h-5 w-5 text-sage-light" aria-hidden="true" data-id="element-187" data-mp="1z5hoczakb4z6" />
              </span>
              <span className="leading-none" data-id="element-188" data-mp="1u7g8en8fnlrx">
                <span className="block font-display text-lg font-semibold tracking-wide" data-id="element-189" data-mp="2rtdjw0oeaqud">CHACON’S</span>
                <span className="mt-1 block text-[10px] font-bold tracking-[0.34em] text-sage-light" data-id="element-190" data-mp="2mutyc1dprh2j">LAWNCARE</span>
              </span>
            </Link>
            <p className="mt-5 max-w-xs text-[15px] leading-relaxed text-white/65" data-id="element-191" data-mp="2htmo7vo3m5sp">
              Christmas Decoration Services — professional Christmas light design and installation for homes and businesses.
            </p>
            <a href={christmasQuoteHref} className="mt-6 inline-flex h-12 items-center justify-center rounded-full bg-[#E3C77F] px-6 text-[13px] font-bold uppercase tracking-[0.08em] text-forest-900 transition-colors hover:bg-white" data-id="element-192" data-mp="16dy379uenguj">
              Get a Free Estimate
            </a>
          </div>

          <nav aria-label="Christmas page" className="lg:col-span-3" data-id="element-193" data-mp="3fnxdsxqlovcj">
            <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-[#E3C77F]" data-id="element-194" data-mp="3knthswzasms3">On This Page</p>
            <ul className="mt-4 space-y-2.5 text-[15px]" data-id="element-195" data-mp="35ynlphvrbcof">
              {pageLinks.map(l => <li key={l.href} data-id="element-196" data-mp="3aqfdtwuk9qgo">
                  <a href={l.href} className="text-white/70 transition-colors hover:text-white" data-id="element-197" data-mp="3aqp5dov985oh">
                    {l.label}
                  </a>
                </li>)}
              <li data-id="element-198" data-mp="31yn8g0ke97iy">
                <Link to="/" className="text-white/70 transition-colors hover:text-white" data-id="element-199" data-mp="31y3neazg630p">
                  Home
                </Link>
              </li>
            </ul>
          </nav>

          <div className="lg:col-span-5" data-id="element-200" data-mp="2ry32iklxjeue">
            <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-[#E3C77F]" data-id="element-201" data-mp="2s18qtxmqicp2">Contact</p>
            <ul className="mt-4 grid gap-4 sm:grid-cols-2" data-id="element-202" data-mp="28ffjb8hao7tx">
              {christmasContacts.map(c => <li key={c.id} lang={c.lang} className="rounded-2xl bg-white/[0.06] p-5 ring-1 ring-white/10" data-id="element-203" data-mp="2ibsanzpda9li">
                  <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-sage-light" data-id="element-204" data-mp="2dc61q2gknfii">
                    {c.heading} — {c.name}
                  </p>
                  <a href={`tel:${c.phoneE164}`} aria-label={c.callAria} className="mt-2 block font-display text-2xl hover:text-[#E3C77F]" data-id="element-205" data-mp="2radvy2m842pz">
                    {c.phoneDisplay}
                  </a>
                  <div className="mt-4 grid grid-cols-2 gap-2" data-id="element-206" data-mp="314e8uqnqyc99">
                    <a href={`tel:${c.phoneE164}`} aria-label={c.callAria} className="inline-flex h-10 items-center justify-center gap-1.5 rounded-full bg-olive px-2 text-[11px] font-bold uppercase tracking-[0.06em] hover:bg-olive-700" data-id="element-207" data-mp="2w4hzebwa5smb">
                      <PhoneIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-208" data-mp="13cmt49jlge9g" /> {c.callLabel}
                    </a>
                    <a href={`sms:${c.phoneE164}`} aria-label={c.textAria} className="inline-flex h-10 items-center justify-center gap-1.5 rounded-full px-2 text-center text-[11px] font-bold uppercase leading-tight tracking-[0.04em] ring-1 ring-white/40 hover:bg-white/10" data-id="element-209" data-mp="18bfwh9562ovw">
                      <MessageSquareIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-210" data-mp="pfpvnp8yzyjl" /> {c.textLabel}
                    </a>
                  </div>
                </li>)}
            </ul>
          </div>
        </div>
        <div className="mt-14 flex flex-col gap-2 border-t border-white/10 pt-6 text-sm text-white/50 sm:flex-row sm:justify-between" data-id="element-211" data-mp="zariufjoqqjj">
          <p data-id="element-212" data-mp="2arhtcav564iy">© {new Date().getFullYear()} Chacon’s Lawncare. All rights reserved.</p>
          <p data-id="element-213" data-mp="3va1zdi6dxlm4">Christmas Decoration Services · Augusta, GA area</p>
        </div>
      </div>
    </footer>;
}